import React from "react";
import { Typography } from "design_system/src";
import HorizontalFoldingSlider from "components/horizontalFoldingSlider/HorizontalFoldingSlider";
import PaymentItem, { PaymentItemProps } from "./PaymentItem";


const data: PaymentItemProps[] = [
  {
    title: <>Los pagos son semanales</>,
    text: <>¿Eres <strong>empleado, independiente o repartes en DiDiFood?</strong> Pagas cada semana a través de nuestra plataforma, <strong>podrás usar tarjeta, transferencia o efectivo (OXXO)</strong> para cubrir tus cuotas.</>,
    imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/pagos_semanales_financiamiento_moto_small",
    desktopImageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/pagos_semanales_financiamiento_moto%20",
    imageAlt: "Pareja en motocicleta – financiamiento de motos con pagos semanales en Ozon",
  },
  {
    title: <>¿Eres repartidor de <strong>Uber</strong>?</>,
    text: <>Cada semana <strong>Uber</strong> retiene tu cuota directamente desde la app y <strong>recibes 7% de descuento en cada cuota</strong> que se retenga.</>,
    imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/pagos_semanales_financiamiento_moto_repartidor_small",
    desktopImageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/pagos_semanales_financiamiento_moto_2",
    imageAlt: "Repartidor en motocicleta – crédito de motos Ozon con pagos semanales",
  },
];

const CreditPayment: React.FC = () => {
  const creditPaymentSectionRef = React.useRef<HTMLDivElement>(null);
  return (
    <section className="dso_container p_y_md">
      <Typography
        scale="heading1"
        scaleMobile="heading3"
        weight="600"
        component="h2"
      >
        Aquí te explicamos como <br className="display_none_mobile" />pagar tu moto
      </Typography>

      <HorizontalFoldingSlider
        name="payment-section"
        data={data.map((item) => <PaymentItem {...item} />)}
        sectionRef={creditPaymentSectionRef}
      />
    </section>
  );
};

export default CreditPayment;
